import { Suspense, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { PlatformSidebar } from './PlatformSidebar';
import { PlatformTopNav } from './PlatformTopNav';
import { MobileHeader } from './MobileHeader';
import { ErrorBoundary, LoadingScreen } from '@/components/ui';

/** Mirrors AppShell.tsx's responsive layout for the platform-admin area. */
export function PlatformShell() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="min-h-screen bg-surface-page">
      <MobileHeader onMenuClick={() => setMobileOpen(true)} />
      <PlatformSidebar
        collapsed={collapsed}
        onToggle={() => setCollapsed((c) => !c)}
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />

      <div className={collapsed ? 'md:pl-20' : 'md:pl-64'} style={{ transition: 'padding-left 300ms ease-in-out' }}>
        <PlatformTopNav />
        <main className="mx-auto max-w-7xl px-4 py-6 md:px-6">
          <ErrorBoundary>
            <Suspense fallback={<LoadingScreen fullScreen={false} />}>
              <Outlet />
            </Suspense>
          </ErrorBoundary>
        </main>
      </div>
    </div>
  );
}
